import {
  updateConfigValues,
  updateSoftwareNumber,
  createChallengesEntry,
} from '../actions/config';
import { resetError } from '../actions/error';
import i18n from '../../i18n';
import { handleEntryPoint } from '../actions/handle-entry-point';
import { getSearchState } from '../../views/search/state/search-state';
import { removeKeyByValue } from '../../helpers/local-storage';

const handlerName = 'InitializeApp';

function softwareNumberUpdated(
  softwareNumber: string,
  currentSoftwareNumber: string,
): boolean {
  return currentSoftwareNumber && currentSoftwareNumber !== softwareNumber
    ? true
    : false;
}

async function handler(payload, store) {
  const { methodName, ...config } = payload;
  const currentState = store.getState();
  const currentSoftwareNumber = currentState.config.softwareNumber;
  await store.dispatch(handleEntryPoint(config.entryPoint));

  if (!getSearchState().executedASearch) {
    getSearchState().applyDefaultSearchState();
  }

  if (config.isClub && config.membershipType === 'free') {
    removeKeyByValue('quickFilters');
  }

  if (config.language) {
    i18n.setLocaleSync(config.language);
  }

  if (softwareNumberUpdated(config.softwareNumber, currentSoftwareNumber)) {
    await store.dispatch(updateSoftwareNumber(config));
    await store.dispatch(updateConfigValues(config));
    store.dispatch(resetError());
  } else {
    store.dispatch(updateConfigValues(config));
  }

  const currentPoint = window?.location?.hash.replace(/^#/, '');
  if (currentPoint) {
    const isChallengeEntry = currentPoint === '/challenges';
    await store.dispatch(createChallengesEntry(isChallengeEntry));
  }
}

export { handlerName, handler };
